<template>
    <div class="container bg_fff">
        <breadcrumb :pages="pages"></breadcrumb>
        <div class="pl15 pr15 pt50 pb50 relative">
                <div class="pages">
                    <print ref="print"  :use-manifest="false">
                            <div class="header flex aic jcc" style="height:150px;">
                                {{detailObj.hopeHosName}}
                            </div>
                            <div class="body">
                                <div class="row bbb relative flex" style="height: 70px;">
                                    <div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">转诊类型</div>
                                    <div class="row bbr flex aic pl20" style="width: 32%;height: 100%;" v-if="$route.params.type == 'check'">检查转诊</div>
                                    <div class="row bbr flex aic pl20" style="width: 32%;height: 100%;" v-else>日间手术转诊</div>
                                    <div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">申请日期</div>
                                    <div class="row flex aic pl20" style="width: 32%;height: 100%;">{{detailObj.createTime | formateTime}}</div>
                                </div>
                                <div class="row bbb relative flex" style="height: 70px;">
                                    <div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">预约医院</div>
                                    <div class="row bbr flex aic pl20" style="width: 32%;height: 100%;">{{detailObj.hopeHosName}}</div>
                                    <div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">预约项目</div>
                                    <div class="row flex aic pl20" style="width: 32%;height: 100%;" v-if="$route.params.type == 'check'">{{detailObj.inspectList | inspectListToString($route.params.type)}}</div>
                                    <div class="row flex aic pl20" style="width: 32%;height: 100%;" v-else>{{detailObj.operationList | inspectListToString($route.params.type)}}</div>
                                </div>
                                <div class="row bbb relative flex" style="height: 70px;">
                                    <div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">预约时间</div>
                                    <div class="row bbr flex aic pl20" style="width: 32%;height: 100%;">{{detailObj.hopeTime | formateTime}}</div>
                                    <div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">申请医院</div>
                                    <div class="row flex aic pl20" style="width: 32%;height: 100%;">{{detailObj.initHosName}}</div>
                                </div>
                                <div class="row bbb relative flex" style="height: 70px;">
                                    <div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">申请科室</div>
                                    <div class="row bbr flex aic pl20" style="width: 32%;height: 100%;">{{detailObj.initDeptName}}</div>
                                    <div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">联系电话</div>
                                    <div class="row flex aic pl20" style="width: 32%;height: 100%;">{{detailObj.docTelphone || ''}}</div>
                                </div>
                                <div class="row bbb relative flex" style="min-height: 80px;">
                                    <div class="row bbr flex aic jcc" style="width: 18%;min-height: 80px;">初步诊断</div>
                                    <div class="row flex aic pl20" style="width: 82%;min-height: 80px;">{{detailObj.tentativeDiagnosis}}</div>
                                </div>
                                <div class="row bbb relative flex" style="min-height: 80px;">
                                    <div class="row bbr flex aic jcc" style="width: 18%;min-height: 80px;">病情描述</div>
                                    <div class="row flex aic pl20" style="width: 82%;min-height: 80px;">{{detailObj.illnessDescription}}</div>
                                </div>
                                <div class="row bbb relative flex" style="height: 70px;">
                                    <div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">患者姓名</div>
                                    <div class="row bbr flex aic pl20" style="width: 32%;height: 100%;">{{detailObj.patName}}</div>
                                    <div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">患者性别</div>
                                    <div class="row flex aic pl20" style="width: 32%;height: 100%;">{{detailObj.patGender | sexFormate}}</div>
                                </div>
                                <div class="row bbb relative flex" style="height: 70px;">
                                    <div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">身份证号</div>
                                    <div class="row bbr flex aic pl20" style="width: 32%;height: 100%;">{{detailObj.patIdcard}}</div>
                                    <div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">患者年龄</div>
                                    <div class="row flex aic pl20" style="width: 32%;height: 100%;">{{detailObj.patAge}}</div>
                                </div>
                                <div class="row bbb relative flex" style="height: 80px;">
                                    <div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">联系方式</div>
                                    <div class="row bbr flex aic pl20" style="width: 32%;height: 100%;">{{detailObj.patMobile}}</div>
                                    <div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">联系地址</div>
                                    <div class="row flex aic pl20" style="width: 32%;height: 100%;">{{detailObj.areaName}} {{detailObj.address}}</div>
                                </div>
                                <div class="row relative flex" style="min-height: 80px;">
                                    <div class="row bbr flex aic jcc" style="width: 18%;min-height: 80px;">安排检查时间</div>
                                    <div class="row bbr flex aic pl20" style="width: 32%;min-height: 80px;">{{detailObj.acceptTime | formateTime}}</div>
                                    <div class="row bbr flex aic jcc" style="width: 18%;min-height: 80px;">医生备注</div>
                                    <div class="row flex aic pl20" style="width: 32%;min-height: 80px;">{{detailObj.remark}}</div>
                                </div>
                            </div>
                            <div class="btnGroup print-hidden">
                                <hos_button content="关闭" @clickEvent="close"></hos_button>
                                <hos_button type="affirm" content="打印" class="ml50" @clickEvent="print"></hos_button>
                            </div>
                    </print>
                </div>
        </div>
    </div>
</template>

<script>
    import Breadcrumb from "../../components/common/Breadcrumb";
    import hos_button from "../../components/hos/hos-button"
    import {hosService} from "../../lib/service/hos"
    export default {
        name: "report",
        components:{
            Breadcrumb,hos_button
        },
        data(){
            return{
                pages:[this.$route.params.type == 'check' ? '检查转诊' : '日间手术转诊','转诊申请'],
                detailObj:{},
            }
        },
        filters:{
            formateTime(time){
                const handlerZero = (value) => {
                    return value < 10 ? '0' + value : value;
                };
                const dateObj = new Date(time);
                const Y = dateObj.getFullYear();
                const m = handlerZero(dateObj.getMonth() + 1);
                const d = handlerZero(dateObj.getDate());
                const W = dateObj.getDay();
                const H = handlerZero(dateObj.getHours());
                const M = handlerZero(dateObj.getMinutes());
                const S = handlerZero(dateObj.getSeconds());
                return Y+'-'+m+'-'+d+' '+H+':'+M
            },
            inspectListToString(arr,type){
                if(type == 'check'){
                    return  arr.map(r => {
                        return r.inspectName
                    }).join(',')
                }else{
                    return  arr.map(r => {
                        return r.operationName
                    }).join(',')
                }
            },
            sexFormate(sex){
                return sex == 'M' ? '男' : '女'
            }
        },
        methods:{
            close(){
                this.$router.back();
            },
            //打印
            print(){
                this.$refs.print.print();
            },
            //查询统计表格数据
            async queryById(){
                this.detailObj = await hosService.queryDetail({
                    id:this.$route.params.id
                })
            }
        },
        async created(){
            await this.queryById();
            this.pageType = this.$route.params.type;
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/hos";
    //A纸大小
    .pages{
        background: white;
        width: 21cm;
        display: block;
        margin: 0 auto;
        margin-bottom: 0.5cm;
        box-shadow: 0 0 0.5cm rgba(0,0,0,0.5);
        padding-bottom: 50px;
        position: relative;
        div{
            border-sizing:border-box;
        }
    }
    .header{
        width: 100%;
        font-family: PingFangSC-Medium;
        font-size: 22px;
        color: #333333;
        letter-spacing: 0;
    }
    .body{
        width: calc(100% - 50px);
        position: relative;
        margin:0 25px 50px 25px;
        border: 1px solid #000000;
    }

    .row{
        width: 100%;
    }
    .btnGroup{
        position: absolute;
        right: 20px;
        bottom:-50px;
    }
</style>